import { createSelector } from 'reselect';
import { RootState } from '../store';
import { MasterCorpSegments } from 'src/models/AppContextModels';
import { CorpSegmentNames } from 'src/constants/corp-segment-constants';
import { ForecastTemplateMasterCorpSegmentDropdownValues } from 'src/models/ForecastModels';

const getCorpSegmentsStore = (state: RootState) => state.corpSegmentsStore;

// Master Corp & Business Segments in Hierarchy Representation.

// Used in CorpSegmentHierarchySelection Modal, OnboardingForm
export const selectMasterCorpSegments = createSelector(getCorpSegmentsStore, (corpSegmentsStore) => corpSegmentsStore.masterCorpSegments);
export const selectMasterCorpSegmentStatus = createSelector(getCorpSegmentsStore, (corpSegmentsStore) => corpSegmentsStore.masterCorpSegmentsStatus);
export const selectDeferredCorpSegmentsStatus = createSelector(
  getCorpSegmentsStore,
  (corpSegmentsStore) => corpSegmentsStore.deferredCorpSegmentsStatus
);

// Used in OnboardingForm
export const selectMasterBusinessSegments = createSelector(getCorpSegmentsStore, (corpSegmentsStore) => corpSegmentsStore.masterBusinessSegments);
export const selectMasterBusinessSegmentStatus = createSelector(
  getCorpSegmentsStore,
  (corpSegmentsStore) => corpSegmentsStore.masterBusinessSegmentsStatus
);

export const selectMasterProjectCorpSegment = createSelector(selectMasterCorpSegments, (masterCorpSegments: MasterCorpSegments[]) =>
  masterCorpSegments.find((corpSegment: MasterCorpSegments) => corpSegment.segment_name === CorpSegmentNames.PROJECT)
);

// Selected CC and PLs in corresponding Business Group
export const selectFilteredCCAndPLOfAllBusinessGroups = createSelector(
  getCorpSegmentsStore,
  (corpSegmentsStore) => corpSegmentsStore.masterCostCenterDropdownValuesForAllBusinessGroups
);

// Utilized in ForecastTemplateGrid, ForecastTemplateGridTable & ForecastTemplateFileUpload
export const selectMasterCorpSegmentDropdownValues = createSelector(
  getCorpSegmentsStore,
  (corpSegmentsStore) => corpSegmentsStore.masterCorpSegmentDropdownValues
);

// Utilized in AccessModificationForm
export const selectMasterCostCenterDropdownValues = createSelector(
  selectMasterCorpSegmentDropdownValues,
  (masterCorpSegmentDropdownValues: ForecastTemplateMasterCorpSegmentDropdownValues[]) =>
    masterCorpSegmentDropdownValues.find((corpSegment) => corpSegment.masterCorpSegmentDisplayName === CorpSegmentNames.COST_CENTER)
      ?.masterCorpSegmentDropdownValues || []
);

// Utilized in AccessModificationForm
export const selectMasterProductLineDropdownValues = createSelector(
  selectMasterCorpSegmentDropdownValues,
  (masterCorpSegmentDropdownValues: ForecastTemplateMasterCorpSegmentDropdownValues[]) =>
    masterCorpSegmentDropdownValues.find((corpSegment) => corpSegment.masterCorpSegmentDisplayName === CorpSegmentNames.PRODUCT_LINE)
      ?.masterCorpSegmentDropdownValues || []
);
